(function () {
    'use strict';

    a3_pilot_reports.factory('DataCleanerFactory', DataCleanerFactory)

    /**
     * @memberof PilotReports
     * @ngdoc factory
     * @name DataCleanerFactory
     * @description 
     *   Cleans the Data of the application
     * @ngInject
     */
    function DataCleanerFactory(localStorageMD5Service, IndexedDBService, GenericService) {
        var objCallbackRatings = objCallbackRatings;

        var service = {
                deleteAllReports: deleteAllReports,
                deleteAllServerData: deleteAllServerData,
                deleteAllData: deleteAllData,
                deleteOrphanedLocalFlights: deleteOrphanedLocalFlights,
                deleteOrphanedLocalReports: deleteOrphanedLocalReports,
                deleteSynchedLocalPilotReports: deleteSynchedLocalPilotReports,
                deleteOldCrewMealsRatings:deleteOldCrewMealsRatings
            }
            /**
             * Delete All Pilot Reports
             * @memberof DataCleanerFactory
             */
        function deleteAllReports() {
            localStorageMD5Service.remove('pilotReportLocalEdits');
            localStorageMD5Service.remove('pilotReportLocalEdit_TEMP');
            deleteOrphanedLocalFlights();
        };

        /**
         * Delete Basic Server data
         * @memberof DataCleanerFactory
         */
        function deleteAllServerData() {
            localStorageMD5Service.remove('flights');
            localStorageMD5Service.remove('reportGuids');
            localStorageMD5Service.remove('aircraftTypes');
            localStorageMD5Service.remove('pilotReportTemplate');
            localStorageMD5Service.remove('syncLog');
            localStorageMD5Service.remove('pilotReportSyncResults');
            localStorageMD5Service.remove('FAQItem');
            localStorageMD5Service.remove('PaxInfo');
            localStorageMD5Service.remove('scheduleChanges');
            localStorageMD5Service.remove('CheckIn');
            localStorageMD5Service.remove('flightCheckIns');

            
            deleteOrphanedLocalFlights();
        };

        /**
         * Delete All Server data
         * @memberof DataCleanerFactory
         */
        function deleteAllData() {
            localStorageMD5Service.clearAll();

            IndexedDBService.deleteDatabase();
        };

        /**
         * Delete local flights that have no stored local reports
         * @memberof DataCleanerFactory
         */
        function deleteOrphanedLocalFlights() {

            var existingLocalFlights = localStorageMD5Service.get('localFlights');
            if (existingLocalFlights == null)
                return;

            var finalLocalFlights = new Array();

            var pilotReportLocalEdits = localStorageMD5Service.get('pilotReportLocalEdits');
            if (pilotReportLocalEdits == null)
                pilotReportLocalEdits = new Array();

            // check every local flight that has a saved pilot report
            for (var i = 0; i < existingLocalFlights.length; i++) {

                var hasPilotReport = false;

                for (var j = 0; j < pilotReportLocalEdits.length; j++) {

                    if ((pilotReportLocalEdits[j].FlightId != null && pilotReportLocalEdits[j].FlightId == existingLocalFlights[i].FlightId) || (pilotReportLocalEdits[j].FlightAimsId != null && pilotReportLocalEdits[j].FlightAimsId == existingLocalFlights[i].FlightAimsId)) {
                        hasPilotReport = true;
                        break;
                    }

                }

                // if it has a pilot report, add it to the flights to save
                if (hasPilotReport)
                    finalLocalFlights.push(existingLocalFlights[i]);
            }

            // save the resulting local flights
            localStorageMD5Service.set('localFlights', finalLocalFlights);
        }

        /**
         * Delete local reports that have no stored local flights
         * @memberof DataCleanerFactory
         */
        function deleteOrphanedLocalReports() {
            var existingLocalPilotReports = localStorageMD5Service.get('pilotReportLocalEdits');
            var flights = localStorageMD5Service.get('flights');

            if (existingLocalPilotReports == null || flights == null || existingLocalPilotReports.length == 0 || flights.length == 0)
                return 0;

            var finalLocalPilotReports = new Array();

            for (var i = 0; i < existingLocalPilotReports.length; i++) {
                var remove = false;

                if (existingLocalPilotReports[i].Status == 'synched') {
                    remove = true;
                    if (existingLocalPilotReports[i].FlightId != null || existingLocalPilotReports[i].FlightAimsId != null) {
                        for (var j = 0; j < flights.length; j++) {
                            if (
                                (existingLocalPilotReports[i].FlightId != null && existingLocalPilotReports[i].FlightId == flights[j].FlightId) || (existingLocalPilotReports[i].FlightAimsId != null && existingLocalPilotReports[i].FlightAimsId == flights[j].FlightAimsId)
                            ) {
                                remove = false;
                            }
                        }
                    }
                }

                if (!remove)
                    finalLocalPilotReports.push(existingLocalPilotReports[i]);
            }

            // save the resulting local reports
            localStorageMD5Service.set('pilotReportLocalEdits', finalLocalPilotReports);

        }

        /**
         * Delete  Synched Local PilotReports
         * @memberof DataCleanerFactory
         */
        function deleteSynchedLocalPilotReports() {

            var existingLocalPilotReports = localStorageMD5Service.get('pilotReportLocalEdits');
            var flights = localStorageMD5Service.get('flights');
            if (existingLocalPilotReports == null || flights == null || existingLocalPilotReports.length == 0 || flights.length == 0)
                return 0;

            var finalLocalPilotReports = new Array();
            var deleted = 0;
            var flight = null;

            var user = localStorageMD5Service.get('user');;
            // check every saved pilot report
            for (var i = 0; i < existingLocalPilotReports.length; i++) {

                var remove = false;

                if (existingLocalPilotReports[i].Status == 'synched') {
                    if (existingLocalPilotReports[i].FlightId != null || existingLocalPilotReports[i].FlightAimsId != null) {
                        for (var j = 0; j < flights.length; j++) {
                            if (
                                (existingLocalPilotReports[i].FlightId != null && existingLocalPilotReports[i].FlightId == flights[j].FlightId) || (existingLocalPilotReports[i].FlightAimsId != null && existingLocalPilotReports[i].FlightAimsId == flights[j].FlightAimsId)
                            ) {
                                for (var h = 0; h < flights[j].pilotReports.length; h++) {
                                    if (flights[j].pilotReports[h].AuthorAimsId == user.aimsId) {
                                        remove = true;
                                        deleted++;
                                    }

                                }
                            }
                        }
                    }
                }

                if (!remove)
                    finalLocalPilotReports.push(existingLocalPilotReports[i]);
            }

            // save the resulting local reports
            localStorageMD5Service.set('pilotReportLocalEdits', finalLocalPilotReports);

            return deleted;
        }

         /**
         * Deletes CrewMealRatings that are older than 20 days
         * @memberof DataCleanerFactory
         */
        function deleteOldCrewMealsRatings(){
            var res = GenericService.list("CrewMealRatings", objCallbackRatings);
            var lastDate = new Date();
            lastDate.setDate(lastDate.getDate() - 20);
            var crewMealIdsFiltered = res.filter(r => new Date(r.TimeStamp) >= lastDate);
            GenericService.saveOne(crewMealIdsFiltered,"CrewMealRatings");
        }

        function objCallbackRatings(){
            this.CrewMealId = null,
            this.TimeStamp = null
        }

        return service;
    };

})();